<template>
  <v-dialog
    title="Edit Config"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    width="400px"
    @open="onOpen"
    @closed="onClosed"
  >
    <el-form class="padding-lr" ref="form" :model="form" :rules="formRules"  @submit.native.prevent>
      <el-form-item prop="value" :label="label">
        <div class="video-size-input" v-if="isVideoUploadMaximumSize">
          <el-input-number
              v-model="form.value"
              controls-position="right"
              step-strictly
              :step="10"
              :min="10"
              :max="500">
          </el-input-number>
          <span class="video-size">MB</span>
        </div>
        <el-input
          v-else
          :type="inputType"
          :rows="5"
          v-model="form.value"
          :placeholder="placeholder"
        >
          <span v-if="isPassword" @click="toggleTypeHandler" slot="suffix">
            <i
              class="el-input__icon el-icon-view"
              :class="{ active: toggleType }"
            />
          </span>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSave"> Save </el-button>
      <el-button @click="dialogVisible = false"> Cancel </el-button>
    </div>
  </v-dialog>
</template>
<script>
import { trimValidate } from "../../utils/validator";
export default {
  name: "EditConfigDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      initForm: false,
      form: {
        value: "",
      },
      formRules: {
        value: [
          {
            required: true,
            tigger: "blur",
            validator: trimValidate("Please input value"),
          },
        ],
      },
      toggleType: false,
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  computed: {
    label() {
      return this.data
        ? this.data.ConfigName.replace(/([a-z])([A-Z])/g, "$1 $2")
        : "";
    },
    placeholder() {
      return `Please input ${this.label.toLowerCase()}`;
    },
    isPassword() {
      return this.data
        ? this.data.ConfigName === "IDoctorAppSignKey" ||
            this.data.ConfigName === "OnlineMeetingAppClient"
        : false;
    },
    isVideoUploadMaximumSize(){
      return this.data ? this.data.ConfigName === "VideoUploadMaximumSize" : false;
    },
    inputType() {
      return this.isPassword
        ? this.toggleType
          ? "text"
          : "password"
        : "textarea";
    },
  },
  methods: {
    onOpen() {
      if (this.data) {
        let rule = this.formRules.value[0];
        rule.message = this.placeholder;
        this.form.value = this.data.ConfigValue;
        if(this.isVideoUploadMaximumSize) {
          rule.type = "number";
          delete rule.validator;
          this.$set( this.formRules.value,0,{...rule});
        }else{
          rule.validator = trimValidate(this.placeholder);
          this.$set( this.formRules.value,0,{...rule});
        }
      }
    },
    onClosed() {
      this.toggleType = false;
      this.$refs.form.resetFields();
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
    toggleTypeHandler() {
      this.toggleType = !this.toggleType;
    },
    onSave() {
      const value = this.form.value;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios
            .get("/sys/updateConfig", {
              params: {
                configValue: typeof value === "string" ? value.trim() : value,
                configID: this.data.ConfigID,
              },
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.$emit("success");
                this.$message.success("Update config successfully");
                this.dialogVisible = false;
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
  }
}
.el-form {
  width: 100%;
}
.dialog-footer {
  text-align: center;
}
.video-size{
  margin-left: 10px;
}
.el-icon-view {
  color: #909399;
  font-size: 14px;
  cursor: pointer;
  &:hover,
  &.active {
    color: $theme-color;
  }
}
</style>
